import {Component, inject} from '@angular/core';
import {FormControl, ReactiveFormsModule, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {TranslateModule} from '@ngx-translate/core';

export interface TextPromptData {
  title: string;
  label: string;
  confirm: string;
  value?: string;
}

/** Richiesta di un nome (nuova cartella, rinomina). Restituisce il testo inserito. */
@Component({
  selector: 'app-text-prompt-dialog',
  standalone: true,
  imports: [ReactiveFormsModule, MatDialogModule, MatFormFieldModule, MatInputModule, TranslateModule],
  template: `
    <h2 mat-dialog-title>{{ data.title | translate }}</h2>
    <form (submit)="$event.preventDefault(); save()">
      <mat-dialog-content>
        <mat-form-field appearance="outline" class="dm-a-field">
          <mat-label>{{ data.label | translate }}</mat-label>
          <input matInput [formControl]="control" cdkFocusInitial autocomplete="off"/>
        </mat-form-field>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button type="button" class="dm-a-btn ghost" mat-dialog-close>{{ 'admin.cancel' | translate }}</button>
        <button type="submit" class="dm-a-btn primary" [disabled]="control.invalid">{{ data.confirm | translate }}</button>
      </mat-dialog-actions>
    </form>
  `,
})
export class TextPromptDialogComponent {
  data: TextPromptData = inject(MAT_DIALOG_DATA);
  private dialogRef = inject(MatDialogRef<TextPromptDialogComponent, string>);
  control = new FormControl(this.data.value ?? '', {nonNullable: true, validators: [Validators.required, Validators.maxLength(200)]});

  save(): void {
    const value = this.control.value.trim();
    if (value) {
      this.dialogRef.close(value);
    }
  }
}
